import React from 'react';
import ReactFullpage from '@fullpage/react-fullpage';


import SekcjaJeden from './Sekcje/SekcjaFirst';
import SekcjaDwa from './Sekcje/SekcjaSecond';
import SekcjaTrzy from './Sekcje/SekcjaTrzy';
import SekcjaCztery from './Sekcje/SekcjaFour';
import CustomNav from './CustomNav';
import CustomNavB from './CustomNav-B';
import NawigacjaGora from './Nav';
import OpadajacaStrona from './OpadajacaStrona';

import { useState, useEffect } from 'react';

const Fullpage = () => {

    const [menuState, setMenuState] = useState(false);

    return (
        <ReactFullpage
            //fullpage options
            licenseKey='gplv3-license'
            scrollingSpeed={1000} /* Options here */
            fixedElements={['#m-nav', '#m-nav-bottom']}
            anchors={['start', 'projects', 'about', 'contact']}
            menu={['#m-nav', '#m-nav-bottom']}

            render={({ state, fullpageApi }) => {
                return (
                    <>
                        <ReactFullpage.Wrapper>
                            <div className="section">
                                <SekcjaJeden />
                            </div>

                            {/* żeby pierwszy slajd nie byl widoczny */}
                            <div className='h-[30vh]'></div>
                            <div className="section">
                                <SekcjaDwa />
                            </div>
                            <div className='h-[30vh]'></div>
                            <div className='section'>
                                <SekcjaTrzy />
                            </div>
                            <div className='h-[30vh]'></div>
                            <div className='section'>
                                <SekcjaCztery />
                            </div>

                        </ReactFullpage.Wrapper>
                    </>
                );
            }}
        />
    );
};

export default function FullPg() {
    const [menuState, setMenuState] = useState(false);

    const handleMenu = () => {
        setMenuState(!menuState);
        console.log(menuState);
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1300);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const marginTopRatio = windowHeight / 33;
    const marginBokRatio = windowWidth / -40;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1300);
            setWindowHeight(window.innerHeight);
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            
            <div className='flex-grow'>
                <div className='h-screen bg-gradient-to-b from-[#061e3d] via-[#07192d] to-[#061e3d] 
                                 text-white'>
                    <Fullpage /> {/* Komponent fullpage */}
                    <OpadajacaStrona isVisible={menuState} /> {/* Opadające menu */}
                </div>
            </div>

            {/* Nawigacja musi byc tutaj bo dodając ją do fixedElements nie działają propsy ani nic*/}
            <NawigacjaGora stanMenu={menuState} zmienMenu={handleMenu} />

            <CustomNavB hamburgerStan={menuState} stan={isMobile ? "fixed" : "hidden"} margines={`${parseInt(marginTopRatio)}rem`} marginesBok={marginBokRatio} />
            <CustomNav hamburgerStan={menuState} stan={isMobile ? "hidden" : "fixed"} />

        </>
    )
}